// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Line1px(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Line1px" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.39648 19.8965L19.8965 3.39648L20.6036 4.10359L4.10359 20.6036L3.39648 19.8965Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Line1px.js.map